import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-279" data-mp="1p4v7cp8lzity">
      <Reveal data-id="element-280" data-mp="1u1ve72da8pm4">
        <SectionHeading id="tomos" align="left" eyebrow="Un sistema progresivo para aprender, hacer y emprender" title="6 Tomos completos" data-id="element-281" data-mp="1u4rg11s93yfu" />
      </Reveal>

      <ol className="mt-5 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-282" data-mp="11fss1o1g622m">
        {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-5" data-id="element-283" data-mp="1bc5lckt2ydwu" data-mpi={i}>
            <span className="font-display text-xs font-bold uppercase tracking-[0.14em] text-accent" data-id="element-284" data-mp="2mrc3hr5lvqe4">
              Tomo {i + 1}
            </span>
            <h3 className="mt-1.5 font-display text-lg font-extrabold uppercase leading-tight text-ink" data-id="element-285" data-mp="2qmxhbn6zmqt4">
              {tomo.title}
            </h3>
            <p className="mt-2 text-sm font-semibold text-volt" data-id="element-286" data-mp="2hnk5wozazs5r">{tomo.lead}</p>
            <p className="mt-1.5 text-sm leading-relaxed text-ink-muted" data-id="element-287" data-mp="2hpn621u671o7">
              {tomo.desc}
            </p>
          </Reveal>)}
      </ol>

      <Reveal className="mt-4 rounded-xl border border-line bg-surface-alt p-5 md:p-6" data-id="element-288" data-mp="27pmghy5pjpbk">
        <h3 className="font-display text-base font-extrabold uppercase text-ink" data-id="element-289" data-mp="22y4gpdff7us6">
          Cada tomo incluye
        </h3>
        <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-290" data-mp="1yxuco6b6vefy">
          {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink-muted" data-id="element-291" data-mp="1tzssfi21192w">
              <CheckIcon size={14} className="mt-1 flex-shrink-0 text-success" strokeWidth={3} data-id="element-292" data-mp="1jzs5lm4y8aty" />
              <span data-id="element-293" data-mp="1aalacxdrrop8">{item}</span>
            </li>)}
        </ul>
      </Reveal>
    </section>;
}